module.exports = __webpack_public_path__ + "static/media/LK_Eye Close.ffe75042.svg";